import Input from 'component/atom/forms/input/input/Input';
import Select from 'component/atom/forms/select/select/Select';
import TextArea from 'component/atom/forms/text-area/TextArea';
import Modal from 'component/hoc/modal/Modal';
import { useFormik } from 'formik';
import { variableManagement, workflow } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import { usePost } from 'hooks/usePost';
import React, { useEffect } from 'react';
import * as Yup from 'yup';
const Form = ({ formik }) => {
  const { data: variableTypes } = useFetch(
    ['variableTypes'],
    workflow.getVariableTypes
  );
  return (
    <form
      autoComplete="off"
      onSubmit={formik.handleSubmit}
      className="formCont"
    >
      <Input
        label="Name"
        placeholder="Enter variable name"
        name="variableName"
        value={formik.values.variableName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.variableName}
        touched={formik.touched.variableName}
      />
      <Select
        label="Type"
        placeholder="Select Type"
        name="type"
        value={formik.values.type}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.type}
        touched={formik.touched.type}
        options={variableTypes?.data?.map((item) => {
          return {
            label: item.inputType,
            value: item.id,
          };
        })}
      />
      <TextArea
        label="Description"
        placeholder="Enter Description"
        name="description"
        value={formik.values.description}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.description}
        touched={formik.touched.description}
      />{' '}
    </form>
  );
};
const NewVariable = ({ isOpen, onClose, setRefetch, item = null, refetch }) => {
  const { mutate: AddVariable, isPending } = usePost({
    onSuccessToast: 'Added Successfully',
    toastType: 'add',
  });
  const { mutate: EditVariable, isPending: isEditing } = usePost({
    onSuccessToast: 'Updated Successfully',
    toastType: 'update',
  });
  const validationSchema = Yup.object({
    variableName: Yup.string().required('Bot Name is Required'),
    type: Yup.string().required('User type is Required'),
    description: Yup.string().required('description is Required'),
  });
  const handleAdd = (values, resetForm) => {
    AddVariable(
      {
        data: values,
        url: variableManagement.create(),
      },
      {
        onSuccess: () => {
          if (setRefetch) setRefetch((prev) => !prev);
          resetForm();
          if (refetch) refetch();
          onClose();
        },
      }
    );
  };

  const handleEdit = (values, resetForm) => {
    const valuesToSend = { ...values, variableId: item?.variableId };
    EditVariable(
      {
        url: variableManagement.update(),
        data: valuesToSend,
        method: 'Put',
      },
      {
        onSuccess: () => {
          setRefetch((prev) => !prev);
          resetForm();
          onClose();
        },
      }
    );
  };
  const formik = useFormik({
    initialValues: {
      variableName: item?.variableName || '',
      type: item?.variableType || '',
      description: item?.description || '',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      item !== null
        ? handleEdit(values, resetForm)
        : handleAdd(values, resetForm);
    },
    enableReinitialize: true,
  });
  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);
  return (
    <div>
      <Modal
        title="New Variable"
        isOpen={isOpen}
        onClose={onClose}
        modalContent={{
          component: <Form formik={formik} />,
        }}
        onSubmit={formik.handleSubmit}
        buttonType="submit"
        onSubmitstyles={{
          onSubmit: {
            label: 'Save',
            type: 'save',
            opicBAckground: true,
          },
        }}
        isLoading={isPending}
      />
    </div>
  );
};

export default NewVariable;
